<template>
  <div class="comment_box">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>评论</span>
        <span class="comment_btn" :class="topOnOff ? 'act' : ''" @click="sortBtn('hot')">热度排序</span>
        <span class="comment_btn" :class="!topOnOff ? 'act' : ''" @click="sortBtn('time')">时间排序</span>
        <el-divider></el-divider>
      </p>
      <!-- <div class="comment_title_top_right">
        <i>{{mescount}}</i><span> 条评论</span>
        <el-divider direction="vertical"></el-divider>
        <i>{{participatecount}}</i><span> 人参与</span>
      </div> -->
    </div>
    <div class="comment_box"
      v-loading="loading"
      element-loading-text="评论列表加载中"
      element-loading-spinner="el-icon-loading"
    >
      <!-- 评论回复发布 -->
      <div class="comment_item my_comment_item">
        <dl class="comment_item_left lf">
          <dt>
            <img :src="currentUserd.portrait" alt="头像">
          </dt>
          <dd>{{currentUserd.name}}</dd>
        </dl>
        <div class="comment_item_right lf">
          <el-input type="textarea" v-model="commentOneText"></el-input>
          <div class="comment_item_right_foot">
            <el-popover
              placement="bottom"
              width="241"
              trigger="click">
              <emoji-view ref="EmotionB" @AppendInputValue="AppendMessageText"></emoji-view>
              <p class="lf my_icon_box" slot="reference">
                <i class="my_icon biaoqing"></i><span class="my_icon_text">表情</span>
              </p>
            </el-popover>
            <p class="rt"><button class="my_follow_btn" @click.prevent="commentOneSub">发布</button></p>
          </div>
        </div>
      </div>
      <div v-if="comments.comments.length === 0" class = "my_none">
        暂无评论
      </div>
      <!-- 评论回复列表 -->
      <div v-for="(item, index) in comments.comments" :key="item.id" class="comment_item comment_item_list">
        <dl class="comment_item_left lf">
          <dt>
            <img :src="item.portrait" alt="头像">
          </dt>
        </dl>
        <div class="comment_item_right lf">
          <div class="comment_item_user_info">
            <a @click="userJump(item.user_id)">{{item.user_name}}</a>
          </div>
          <!-- 屏蔽/没有删除 -->
          <div v-if="item.shield === 1 && item.delete_time === 0" class="comment_item_user_text comment_item_user_text_glay">该条评论已被作者屏蔽</div>
          <!-- 没有屏蔽/删除 -->
          <div v-else-if="item.shield !== 1 && item.delete_time !== 0" class="comment_item_user_text comment_item_user_text_glay">该条评论已被删除</div>
          <!-- 屏蔽/删除 -->
          <div v-else-if="item.shield === 1 && item.delete_time !== 0" class="comment_item_user_text comment_item_user_text_glay">该条评论已被删除</div>
          <div v-else class="comment_item_user_text" v-html="item.content"></div>
          <div class="comment_item_user_other">
            <el-breadcrumb separator="·">
              <el-breadcrumb-item style="height: 20px; line-height: 20px;">{{item.time}}</el-breadcrumb-item>
              <el-breadcrumb-item v-show="item.is_mes_like === 1" class="my_icon_box act"><a @click="mesCanceLike(item.id, index, '', 'one')"><i class="my_icon dianzan"></i><span class="my_icon_text">{{item.like}}</span></a></el-breadcrumb-item>
              <el-breadcrumb-item v-show="item.is_mes_like === 0" class="my_icon_box"><a @click="mesDoLike(item.id, index, '', 'one')"><i class="my_icon dianzan"></i><span class="my_icon_text">{{item.like}}</span></a></el-breadcrumb-item>
              <el-breadcrumb-item class="my_icon_box" v-if="currentUserd !== null"><a @click="replySolid(item.id)"><i class="my_icon pinglun"></i><span class="my_icon_text">回复</span></a></el-breadcrumb-item>
              <el-breadcrumb-item class="my_icon_box" v-if="currentUserd !== null && user.id === currentUserd.id">
                <a v-if="item.shield === 1" @click="shieldMesSuccess()">
                  <i class="my_icon jubao"></i><span class="my_icon_text">已屏蔽</span>
                </a>
                <a v-else @click="shieldMes(item.id, index, '', 'one')">
                  <i class="my_icon jubao"></i><span class="my_icon_text">屏蔽</span>
                </a>
              </el-breadcrumb-item>
              <el-breadcrumb-item class="my_icon_box" v-if="item.delete_time === 0 && currentUserd !== null && item.user_id === currentUserd.id"><a @click="delMes(item.id, index, '', 'one')"><i class="my_icon shanchu"></i><span class="my_icon_text">删除</span></a></el-breadcrumb-item>
              <el-breadcrumb-item class="my_icon_box" v-if="item.shield !== 1 && item.delete_time === 0 && currentUserd !== null && item.user_id !== currentUserd.id"><a @click="reportMes(item.id)"><i class="my_icon jubao"></i><span class="my_icon_text">举报</span></a></el-breadcrumb-item>
            </el-breadcrumb>
            <transition name="el-zoom-in-top">
              <div v-show="textareaOneOnOff === item.id" class="comment_item_textarea">
                <el-input type="textarea" v-model="commentTwoText"></el-input>
                <div class="comment_item_right_foot">
                  <el-popover
                    placement="bottom"
                    width="241"
                    trigger="click">
                    <emoji-view ref="EmotionB" @AppendInputValue="AppendTwoMessageText"></emoji-view>
                    <p class="lf my_icon_box" slot="reference">
                      <i class="my_icon biaoqing"></i><span class="my_icon_text">表情</span>
                    </p>
                  </el-popover>
                  <p class="rt"><button class="my_follow_btn" @click.prevent="replyMes(item.id, 0, item.user_id, index)">回复</button></p>
                </div>
              </div>
            </transition>
          </div>
          <!-- 二级回复列表 -->
          <div v-if="item.item.length > 0" class="comment_item_reply_list">
            <div v-for=" (n, twoIndex) in item.item" :key="n.id" class="comment_item_reply_item">
              <div class="comment_item_reply_head">
                <div class="comment_item_reply_head_left lf">
                  <img :src="n.portrait" alt="">
                  <a v-if="n.reply_user_name === null" @click="userJump(n.user_id)"><i>{{n.user_name}} </i></a>
                  <span v-else ><a @click="userJump(n.user_id)">{{n.user_name}}</a> 回复 <i>{{n.reply_user_name}}</i></span>
                  <span>{{n.time}}</span>
                </div>
              </div>
              <!-- 屏蔽/没有删除 -->
              <div v-if="n.shield === 1 && n.delete_time === 0" class="comment_item_user_text comment_item_user_text_glay">该条评论已被作者屏蔽</div>
              <!-- 没有屏蔽/删除 -->
              <div v-else-if="n.shield !== 1 && n.delete_time !== 0" class="comment_item_user_text comment_item_user_text_glay">该条评论已被删除</div>
              <!-- 屏蔽/删除 -->
              <div v-else-if="n.shield === 1 && n.delete_time !== 0" class="comment_item_user_text comment_item_user_text_glay">该条评论已被删除</div>
              <div v-else class="comment_item_user_text" v-html="n.content"></div>
              <div class="comment_item_user_other">
                <el-breadcrumb separator="·">
                  <el-breadcrumb-item v-show="n.is_mes_like === 1" class="my_icon_box act"><a @click="mesCanceLike(n.id, index, twoIndex, 'two')"><i class="my_icon dianzan"></i><span class="my_icon_text">{{n.like}}</span></a></el-breadcrumb-item>
                  <el-breadcrumb-item v-show="n.is_mes_like === 0" class="my_icon_box"><a @click="mesDoLike(n.id, index, twoIndex, 'two')"><i class="my_icon dianzan"></i><span class="my_icon_text">{{n.like}}</span></a></el-breadcrumb-item>
                  <el-breadcrumb-item class="my_icon_box" v-if="currentUserd !== null"><a><i class="my_icon pinglun"></i><span @click="replyTwoSolid(n.id)" class="my_icon_text">回复</span></a></el-breadcrumb-item>
                  <el-breadcrumb-item class="my_icon_box" v-if="currentUserd !== null && user.id === currentUserd.id">
                    <a v-if="n.shield === 1" @click="shieldMesSuccess()">
                      <i class="my_icon jubao"></i><span class="my_icon_text">已屏蔽</span>
                    </a>
                    <a v-else @click="shieldMes(n.id, index, twoIndex, 'two')">
                      <i class="my_icon jubao"></i><span class="my_icon_text">屏蔽</span>
                    </a>
                  </el-breadcrumb-item>
                  <el-breadcrumb-item class="my_icon_box" v-if="n.delete_time === 0 && currentUserd !== null && n.user_id === currentUserd.id"><a @click="delMes(n.id, index, twoIndex, 'two')"><i class="my_icon shanchu"></i><span class="my_icon_text">删除</span></a></el-breadcrumb-item>
                  <el-breadcrumb-item class="my_icon_box" v-if="n.shield !== 1 && n.delete_time === 0 && currentUserd !== null && n.user_id !== currentUserd.id"><a @click="reportMes(n.id)"><i class="my_icon jubao"></i><span class="my_icon_text">举报</span></a></el-breadcrumb-item>
                </el-breadcrumb>
                <transition name="el-zoom-in-top">
                  <div v-show="textareaTwoOnOff === n.id" class="comment_item_textarea">
                    <el-input type="textarea" v-model="commentTwoText"></el-input>
                    <div class="comment_item_right_foot">
                      <p class="lf my_icon_box"><i class="my_icon biaoqing"></i><span class="my_icon_text">表情</span></p>
                      <p class="rt"><button class="my_follow_btn" @click.prevent="replyMes(item.id, n.id, n.user_id, index)">回复</button></p>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <div v-if="item.count > 1 && item.item.length < item.count" class="comment_item_user_more">
              <a @click.prevent="moreReply(item.id,index,item.item.length)">点击查看更多回复 ( {{item.count - item.item.length}} ) >></a>
            </div>
          </div>
        </div>
      </div>
      <!-- 举报弹窗 -->
      <el-dialog title="举报信息" :visible.sync="reportLayer" width="400px">
        <el-form :model='report'>
          <el-form-item label="举报类别" label-width='80px'>
            <el-select v-model="report.type" placeholder="请选择举报类别">
              <el-option label="垃圾广告" value="垃圾广告"></el-option>
              <el-option label="辱骂人身攻击等不友善行为" value="辱骂人身攻击等不友善行为"></el-option>
              <el-option label="涉政" value="涉政"></el-option>
              <el-option label="其它原因" value="其它原因"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="reportLayer = false">取 消</el-button>
          <el-button type="primary" @click="reportMesConfirm">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div v-if="comments.comments.length > 0" class="hr_page">
      <page-button :list = "comments.comments"
      :limit = "page.limit"
      @page = "morePage"
      ref="page"></page-button>
    </div>
  </div>
</template>

<script>
import page from './page.vue'
import emoji from './emoji.vue'
export default {
  name: 'comment',
  components: {
    pageButton: page,
    emojiView: emoji
  },
  props: {
    comments: { // 评论列表
      type: Object,
      required: true
    },
    user: { // 作者信息
      type: Object,
      required: true
    },
    listId: { // 文章id
      required: true
    }
    // mescount: { // 评论数
    //   required: true
    // },
    // participatecount: { // 参与人数
    //   required: true
    // }
  },
  data () {
    return {
      loading: true, // 评论列表加载动画
      topOnOff: true, // 头部栏目开关
      commentOneText: '', // 一级回复内容
      commentTwoText: '', // 二级回复内容
      textareaOneOnOff: -1, // 一级回复显示开关
      textareaTwoOnOff: -1, // 二级回复显示开关
      page: { // 评论列表获取所需参数
        type: 1, // 1 热度排序 2 时间排序 默认热度排序
        dynamic_id: '', // 文章ID
        page: 1, // 页码 默认第1页
        limit: 10 // 查询个数
      },
      twoPage: { // 二级评论列表获取所需参数
        dynamic_id: '', // 文章ID
        mes_id: '', // 一级评论ID
        limit: 15, // 条数
        start: 1 // 现在显示的总条数
      },
      currentUser: {}, // 当前用户信息
      reportLayer: false, // 举报弹窗开关
      report: { // 举报类别
        dynamic_id: '',
        mes_id: '', // 举报信息id
        type: '' // 举报信息类别
      }
    }
  },
  created () {
    this.page.article_id = this.listId
    this.currentUserd = this.$store.state.user.info
    this.loading = false
  },
  methods: {
    // 评论列表排序
    sortBtn (type) {
      const vueThat = this
      vueThat.topOnOff = !vueThat.topOnOff
      vueThat.comments.comments = [] // 重置评论列表
      vueThat.loading = true // 开启加载动画
      vueThat.page.dynamic_id = vueThat.listId
      vueThat.page.page = 1
      if (type === 'time') {
        vueThat.page.type = 2
        vueThat.myApi.boardMesSort(vueThat.page).then((res) => {
          if (res.data.code === 200) {
            vueThat.comments.comments = res.data.data // 评论列表赋值
            vueThat.loading = false // 关闭加载动画
          }
        })
      } else {
        vueThat.page.type = 1
        vueThat.myApi.boardMesSort(vueThat.page).then((res) => {
          if (res.data.code === 200) {
            vueThat.comments.comments = res.data.data // 评论列表赋值
            vueThat.loading = false // 关闭加载动画
          }
        })
      }
    },
    // 一级评论回复框
    replySolid (id) {
      console.log(id)
      this.textareaOneOnOff = id
      this.textareaTwoOnOff = -1
      this.commentTwoText = ''
    },
    // 一级评论提交
    commentOneSub () {
      const vueThat = this
      if (vueThat.commentOneText !== '') {
        vueThat.myApi.boardDynamicMes({ dynamic_id: vueThat.listId, content: vueThat.commentOneText }).then((res) => {
          if (res.data.code === 200) {
            vueThat.$message({
              message: '评论发布成功',
              type: 'success'
            })
            vueThat.commentOneText = ' '
            vueThat.topOnOff = false
            vueThat.page.dynamic_id = vueThat.listId
            vueThat.page.type = 2
            vueThat.myApi.boardMesSort(vueThat.page).then((res) => {
              if (res.data.code === 200) {
                vueThat.comments.comments = res.data.data // 评论列表赋值
                vueThat.loading = false // 关闭加载动画
              }
            })
          }
        })
      }
    },
    // 二级评论回复框
    replyTwoSolid (id) {
      this.textareaTwoOnOff = id
      this.textareaOneOnOff = -1
      this.commentTwoText = ''
    },
    // 二级评论提交
    replyMes (oneId, towId, rid, index) {
      const vueThat = this
      if (vueThat.commentTwoText !== '') {
        vueThat.myApi.boardleReplyMes({ dynamic_id: vueThat.listId, level_one_id: oneId, reply_id: towId, reply_user_id: rid, content: vueThat.commentTwoText }).then((res) => {
          if (res.data.code === 200) {
            vueThat.$message({
              message: '评论发布成功',
              type: 'success'
            })
            vueThat.commentTwoText = ''
          }
        })
      }
    },
    // 评论点赞
    mesDoLike (id, index, twoIndex, type) {
      const vueThat = this
      vueThat.myApi.BoardMesDoLike({ list_id: vueThat.listId, mes_id: id }).then((res) => {
        if (res.data.code === 200) {
          switch (type) {
            case 'one':
              vueThat.comments.comments[index].is_mes_like = 1
              vueThat.comments.comments[index].like += 1
              break
            case 'two':
              vueThat.comments.comments[index].item[twoIndex].is_mes_like = 1
              vueThat.comments.comments[index].item[twoIndex].like += 1
              break
          }
        }
      })
    },
    // 取消评论点赞
    mesCanceLike (id, index, twoIndex, type) {
      const vueThat = this
      vueThat.myApi.BoardMesCanceLike({ list_id: vueThat.listId, mes_id: id }).then((res) => {
        if (res.data.code === 200) {
          switch (type) {
            case 'one':
              vueThat.comments.comments[index].is_mes_like = 0
              vueThat.comments.comments[index].like -= 1
              break
            case 'two':
              vueThat.comments.comments[index].item[twoIndex].is_mes_like = 0
              vueThat.comments.comments[index].item[twoIndex].like -= 1
              break
            case 'new':
              vueThat.comments.comments[index].item[twoIndex].is_mes_like = 0
              vueThat.comments.comments[index].item[twoIndex].like -= 1
              break
          }
        }
      })
    },
    // 评论屏蔽
    shieldMes (id, index, twoIndex, type) {
      const vueThat = this
      const shieldMesId = {
        mes_id: id,
        list_id: vueThat.listId
      }
      vueThat.myApi.BoardShieldMess(shieldMesId).then((res) => {
        if (res.data.code === 200) {
          vueThat.$message({
            message: '屏蔽成功！',
            type: 'success'
          })
          switch (type) {
            case 'one':
              vueThat.comments.comments[index].shield = 1
              break
            case 'two':
              vueThat.comments.comments[index].item[twoIndex].shield = 1
              break
          }
        }
      })
    },
    // 评论已屏蔽
    shieldMesSuccess () {
      this.$message({
        message: '该条评论已被屏蔽！',
        type: 'success'
      })
    },
    // 评论删除
    delMes (id, index, twoIndex, type) {
      const vueThat = this
      vueThat.$confirm('此操作将永久删除该评论, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        vueThat.myApi.BoardDelBoardMes({ mes_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
      }).catch(() => {})
    },
    // 评论举报按钮
    reportMes (id) {
      this.reportLayer = true
      this.report.mes_id = id
    },
    // 评论举报确认按钮
    reportMesConfirm () {
      const vueThat = this
      vueThat.report.dynamic_id = vueThat.listId
      vueThat.myApi.BoardReportMes(vueThat.report).then((res) => {
        if (res.data.code === 200) {
          vueThat.reportLayer = false
          vueThat.$message({
            message: '举报信息提交成功！',
            type: 'success'
          })
        }
      })
    },
    // 更多评论
    morePage (num) {
      const vueThat = this
      vueThat.page.dynamic_id = vueThat.listId
      vueThat.page.page = num
      vueThat.myApi.boardMesSort(vueThat.page).then((res) => {
        if (res.data.code === 200) {
          for (let i = 0; i < res.data.data.length; i++) {
            vueThat.comments.comments.push(res.data.data[i])
          }
        }
      })
    },
    // 更多回复
    moreReply (id, index, num) {
      const vueThat = this
      vueThat.twoPage.dynamic_id = vueThat.listId
      vueThat.twoPage.mes_id = id
      vueThat.twoPage.start = num
      vueThat.myApi.boardTowMesList(vueThat.twoPage).then((res) => {
        if (res.data.code === 200) {
          for (let i = 0; i < res.data.data.length; i++) {
            vueThat.comments.comments[index].item.push(res.data.data[i])
          }
        }
      })
    },
    // 一级回复表情选中后追加在input
    AppendMessageText (EmotionChinese) {
      this.commentOneText += EmotionChinese
    },
    // 二级回复表情选中后追加在input
    AppendTwoMessageText (EmotionChinese) {
      this.commentTwoText += EmotionChinese
    },
    // 个人中心页面跳转
    userJump (rid) {
      const routeData = this.$router.resolve({
        path: '/personalCenter/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped="scoped">
  .comment_box .comment_item.my_comment_item .comment_item_right .el-textarea textarea{
    height: 70px;
  }
</style>
